import { ThemeOptions } from '@material-ui/core'

const muiTheme: ThemeOptions = {
  palette: {
    primary: { main: '#FA7600', '500': '#FFC600', '100': '#f8c5d3', '50': '#fceef2', '700': '#E60021' ,
      'A700': '#000' // untuk table
    },
    secondary: { main: '#FA7600' }
  },
  typography: {
    fontFamily: 'Trueno'
  },
  overrides: {
    MuiButton: {
      root: {
        // height: '48px',
        borderRadius: 0,
        boxShadow: '0 0 0',
        fontWeight: 600
      },
      contained: {
        boxShadow: '0 0 0',
      }
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 0
      }
    }

  }
}

export default {
  banner: {
    src: '/smartfren/banner.png'
  },
  illustration: {
    poweredBy: 'sf-powered-by',
    error: 'g-error',
    start: 'g-start',
    faq: 'g-faq',
    inProcess: 'g-inProcess',
    inDevelopment: 'g-inDevelopment',
    transferSuccess: 'g-transfer',
    searchNotFound: 'g-search-not-found',
    success: 'g-success',
    init: 'g-init'
  },
  headerIcons: {
    // inbox: 'sf-header-inbox',
    // home: 'sf-header-home',
    // campaign: 'sf-header-campaign',
    // channel: 'sf-header-channel',
    // conversation: 'sf-header-conversation',
    // setting: 'sf-header-setting',
    // analytics: 'sf-header-analytics',
  },
  muiTheme: muiTheme,
  colors: {
    primary: ['#FA7600', '#FFA6C4', '#f9dabf', '#E5E5E5'],
    contrastPrimary: ['#FFF', '', 'black']
  },
  analytic: {
    background: '#F9F9F9',
    leftPaneStyle: {
      borderLeft: 'none',
      borderRight: '1px solid #FDE8EF',
      paddingRight: 0
    },
    menuItemStyle: {
      borderLeft: 'none',
      paddingRight: 12
    }
  },
  setting: {
    menuItemStyle: {
      borderLeft: 'none',
    }
  },
  head: {
    icon: '/grahacom/favicon.ico',
    text: 'Grahacom'
  },
  header: {
    logo: '/grahacom/logo.jpeg',
    logoStyle: {
      marginBottom: '20px',
      marginTop: '12px',
      width: '40px',
    },
    // broadcastIconUrl: '/smartfren/icon_broadcast.svg',
    // AnalyticsIcon: BarChart,
    // InboxIcon: MailOutline,
    styleProfileIcon: {
      background: '#FA7600',
      color: '#FFF'
    },
    background: '#FFFFFF',
    menuActiveColor: '#FA7600',
    menuColor: 'rgba(29, 29, 29, 0.4)',
    menuActiveBackground: 'rgba(251, 31, 91, 0.05)',
    menuBorderRight: '3px solid #FA7600',
  },
  login: {
    logoUrl: '/grahacom/logo.jpeg',
    button: {
      background: '#FA7600'
    }
  },
  broadcast: {
    background: 'rgb(249, 249, 249)'
  },
  dataTableTheme: {
    text: {
      primary: '#000000',
      secondary: 'black',
      disabled: 'rgba(0, 0, 0, 0.54)'
    },
    context: {
      background: '#e3f2fd',
      text: 'rgba(0, 0, 0, 0.87)',
    },
    sortFocus: {
      default: '#4087BF',
    },
    striped: {
      default: '#FAFAFA',
      text: 'rgba(0, 0, 0, 0.87)',
    },
    // highlightOnHover: {
    //   default: '#FFE9EA',
    //   text: 'black'
    // }
  },
  botStudio: {
    collapsableLogo: '/grahacom/logo.jpeg',
    collapsableStyle: {
      width: '30px'
    },
    expandedLogo: '/grahacom/logo.jpeg',
    expandedStyle: {
      width: '100px'
    }
  },
  componentStyle: {
    borderRadius: undefined
  },
  instagramRedirect: {
    logoUrl: '/grahacom/logo.jpeg'
  }
}